module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_d2/sec03_sp_6948849cb62f150fe8d2ea1195b02b4c.jpg";